import { captureStack1fzi4aczwc4hg as captureStack } from './js/coreRuntime.mjs';
import { RuntimeException1r3t0zl97011n as RuntimeException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_KotlinNothingValueException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var KotlinNothingValueExceptionClass;
function KotlinNothingValueException() {
  if (KotlinNothingValueExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_KotlinNothingValueException_56qecr_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_KotlinNothingValueException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'KotlinNothingValueException', $.new_kotlin_KotlinNothingValueException_56qecr_k$);
    KotlinNothingValueExceptionClass = $;
  }
  return KotlinNothingValueExceptionClass;
}
//region block: exports
export {
  KotlinNothingValueException as KotlinNothingValueException2zr0cdstak0a9,
};
//endregion

//# sourceMappingURL=ExceptionsH.mjs.map
